import { UIDataModel, UIComponentHandler, UIComponentState } from '../../toolkit/uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../toolkit/uicomponentcss';
import { LoginWrapperViewImpl } from './loginwrapperview';
import { LoginWrapperCSSStyleImpl } from './loginwrappercss';
import { MainWrapperComponentProps, MainWrapperComponent } from '../mainwrappercomponent';


export class LoginWrapperComponent extends MainWrapperComponent<MainWrapperComponentProps, UIComponentState>
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new LoginWrapperViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new LoginWrapperCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/loginwrappercomponent.tsx